export default __webpack_public_path__ + "static/about-us-giving-back-652da277c6d5ad43d1d4a9b69b4a49f1.webp";